import {Input} from 'antd';
import {FormInstance} from 'antd/es/form';
import cn from 'classnames';
import React, {
    useEffect, useState, FC, FormEvent,
} from 'react';
import {useSelector} from 'react-redux';

import {DATA_MODULE} from 'modules/data';
import {EEntityType} from 'shared/constants/entities';
import {TAppState} from 'store/config/types';

import 'components/form/field/field.less';

export interface IDependentsFieldProps {
    onChange?: (value: any) => void;
    form?: FormInstance;
    value: string;
    dependFieldKey: string;
    maskField?: string;
    fieldKey: string;
    parentEntityName: string;
    isDependsOnMainFilter?: string;
    isDisplay?: boolean;
    disabled?: boolean;
    entityName?:string;
}

export const DependentsField: FC<IDependentsFieldProps> = (
    {
        form,
        value,
        onChange,
        dependFieldKey,
        maskField,
        parentEntityName,
        isDependsOnMainFilter,
        disabled,
        entityName,
        ...props
    }: IDependentsFieldProps,
) => {
    const [mainFieldValue, setMainFieldValue] = useState<string | number | undefined>(value);
    const data: any = useSelector(
        (state: TAppState) => state[DATA_MODULE][parentEntityName
          ?? entityName]?.[EEntityType.FILTER]?.data[dependFieldKey],
    );

    const setFilePathValue = (mainValue: string | null = null) => {
        form?.setFieldsValue({
            [dependFieldKey]: [mainValue, maskField].join(''),
        });
    };

    useEffect(() => {
        if (data && typeof data.value !== 'undefined' && isDependsOnMainFilter === 'Y') {
            setMainFieldValue(data?.value);
            if (onChange) onChange(data?.value);
        }
    }, [data?.value, mainFieldValue]);

    const handleBlur = (e: FormEvent<HTMLInputElement>) => {
        const newValue = e.currentTarget.value;
        if (newValue) setFilePathValue(newValue);
        if (onChange) onChange(newValue);
    };

    return (
        <div className={cn({'extra-borders': disabled})}>
            <Input
                onChange={(e: FormEvent<HTMLInputElement>) => setMainFieldValue(e.currentTarget.value)}
                value={mainFieldValue}
                onBlur={handleBlur}
                disabled={disabled}
                {...props}
            />
        </div>
    );
};
